"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent_1 = __importDefault(require("superagent"));
// type SignedUrlResponse = {
//   url: string;
//   additional_fields: Record<string, string>;
//   s3_key: string;
// };
var S3FileUploader = /** @class */ (function () {
    function S3FileUploader(_a) {
        var signedUrlEndpoint = _a.signedUrlEndpoint;
        this.signedUrlEndpoint = signedUrlEndpoint;
        this.abortControllerMap = new Map();
    }
    S3FileUploader.prototype.upload = function (file, _a) {
        var _this = this;
        var _b;
        var onProgress = _a.onProgress, onComplete = _a.onComplete, onError = _a.onError;
        this.abortControllerMap.set(file, new AbortController());
        fetch(window.location.origin + "/tally/4/get_csv_url/", 
        // this.signedUrlEndpoint,
        {
            method: 'POST',
            body: JSON.stringify({
                filename: file.name,
            }),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            signal: (_b = this.abortControllerMap.get(file)) === null || _b === void 0 ? void 0 : _b.signal,
        }).then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onProgress(0);
                        return [4 /*yield*/, resp.json()];
                    case 1:
                        data = _a.sent();
                        superagent_1.default.put(data.url).type(file.type).send(file).on('progress', function (e) {
                            onProgress(e.percent || 0);
                        }).on('response', function () {
                            onComplete(data.s3_key);
                        }).on('error', function () {
                            onError('Error uploading file.');
                        }).end(function (err, res) {
                            if (err) {
                                onError(err.toString());
                            }
                            else {
                                console.log(res.body);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); }).catch(function () { return onError('Error uploading file.'); });
        return function () {
            var _a;
            (_a = _this.abortControllerMap.get(file)) === null || _a === void 0 ? void 0 : _a.abort();
        };
    };
    return S3FileUploader;
}());
exports.default = S3FileUploader;
